import React from "react";
import { Flex, Box } from "@rebass/grid";

const Container = ({ children, style, ...props }) => (
  <Box
    {...props}
    mx="auto"
    style={{
      ...style,
      maxWidth: "1024px",
      clear: "both",
    }}
  >
    <Flex flexWrap="wrap" mx={[1, 1, -2]}>
      {children}
    </Flex>
  </Box>
);

export default Container;
